import { FC, ReactNode } from 'react'

import { CampaignOption, CampaignOptionType } from './Option'
import { CampaignTag, CampaignTagType } from './Tag'

import { Form, FormType } from './form/Form'
import { CampaignSendEmailType, SendEmail } from './SendEmail'
import { CampaignStatistic } from './Statistic'
import { CampaignStatisticRow } from './StatisticRow'

export const Campaign: FC &
  CampaignTagType &
  CampaignOptionType &
  FormType &
  CampaignSendEmailType & {
    Statistic: typeof CampaignStatistic
    StatisticRow: typeof CampaignStatisticRow
  } = (): ReactNode => <></>

Campaign.Tag = CampaignTag
Campaign.Option = CampaignOption
Campaign.Form = Form
Campaign.SendEmail = SendEmail
Campaign.Statistic = CampaignStatistic
Campaign.StatisticRow = CampaignStatisticRow
